module.exports = __webpack_public_path__ + "img/antes_despues_203.855f3698.png";